document.addEventListener("DOMContentLoaded", function () {
  const page_url = window.location.href;

  // -------------------------------------------------------
  // LANDING PAGE - Build image slideshow + featured blocks
  // -------------------------------------------------------
  let imgspath = "";

  const imageClasses = [
    ".first_slideshow_image_gift",
    ".first_slideshow_image_gift2",
    ".first_slideshow_image_gift3",
    ".first_slideshow_image_gift4",
  ];

  imageClasses.forEach((cls) => {
    const el = document.querySelector(cls);
    if (el && typeof el.value !== "undefined") {
      imgspath += `<img src="${el.value}">`;
    }
  });

  const giftreggeLanding = document.querySelector(".giftreggie-landing");

  if (giftreggeLanding) {
    // Insert image wrapper before .giftreggie-landing
    const imageWrapper = document.createElement("div");
    imageWrapper.className = "gift_image_wrapper image_wrapper";
    imageWrapper.innerHTML = imgspath;
    giftreggeLanding.parentNode.insertBefore(imageWrapper, giftreggeLanding);

    // Insert description after .giftreggie-landing h3
    // const landingH3 = giftreggeLanding.querySelector("h3");
    // if (landingH3) {
    //   const description = document.createElement("div");
    //   description.id = "description";
    //   description.textContent =
    //     "In celebration of choosing to move through each new day together — as friends, family, and lovers — a collection of pieces both sensible and sublime. Perfect picks for everyone, including yourself.";
    //   landingH3.insertAdjacentElement("afterend", description);
    //   landingH3.textContent = "Gift Registry";
    // }

    // Wrap .giftreggie-landing and image_wrapper in .main_wrapper
    const mainWrapper = document.createElement("div");
    mainWrapper.className = "main_wrapper";
    giftreggeLanding.parentNode.insertBefore(mainWrapper, imageWrapper);
    mainWrapper.appendChild(imageWrapper);
    mainWrapper.appendChild(giftreggeLanding);

    // Insert featured block after .main_wrapper
    const featuredHTML = `
      <div class="featured_test">
        <div class="test_wrapper_inner">
          <div class="test_inner_column">
            <div class="featured_text_title">Cleverly Curated</div>
            <div class="featured_text_content">Joyful occasions or "just because" — perfect picks for everyone, including yourself.</div>
            <div class="button_wrapper"><a href="https://nickeykehoe.com/collections/gift-registry">SHOP NOW</a></div>
          </div>
          <div class="test_inner_column">
            <div class="featured_text_title">Browsing Made Simple</div>
            <div class="featured_text_content">Let us help you find the perfect gift. Visit us in store or contact us for a personalized trip through our latest collection.</div>
            <div class="button_wrapper"><a href="https://nickeykehoe.com/pages/contact">SCHEDULE</a></div>
          </div>
          <div class="test_inner_column">
            <div class="featured_text_title">Registry Completion Discount</div>
            <div class="featured_text_content">Didn't receive everything on your list?<br> Gift registrants are eligible for a discount code valid for one month following your event to pick up the last few items missing from your list.</div>
            <div class="button_wrapper"><a href="https://nickeykehoe.com/apps/giftregistry/signup">CREATE A REGISTRY</a></div>
          </div>
          <div class="test_inner_column">
            <div class="featured_text_title">Gift Cards</div>
            <div class="featured_text_content">Wax sealed and letter-pressed — the gift that always fits. Mailed now or scheduled for delivery on the date of your choice. Considered gift wrapping and handwritten notes also available at checkout.</div>
            <div class="button_wrapper"><a href="https://nickeykehoe.com/products/gift-certificate">SHOP NOW</a></div>
          </div>
          <div class="test_inner_column">
            <div class="featured_text_title">Housewarming</div>
            <div class="featured_text_content">Delightful objects for everyday living. Peruse our selection of thoughtful gifts for your favorite host.</div>
            <div class="button_wrapper"><a href="https://nickeykehoe.com/apps/giftregistry">SHOP NOW</a></div>
          </div>
          <div class="test_inner_column">
            <div class="featured_text_title">A Love for Life Together</div>
            <div class="featured_text_content">In celebration of choosing to move through each new day together — a collection of pieces both sensible and sublime.</div>
            <div class="button_wrapper"><a href="https://nickeykehoe.com/collections/gift-registry">SHOP NOW</a></div>
          </div>
        </div>
      </div>`;

    // mainWrapper.insertAdjacentHTML("afterend", featuredHTML);

    // Init Slick slider (requires slick to be loaded)
    if (typeof jQuery !== "undefined" && jQuery.fn.slick) {
      jQuery(".gift_image_wrapper.image_wrapper").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        adaptiveHeight: true,
      });
    }
  }

  // -------------------------------------------------------
  // FIND PAGE
  // -------------------------------------------------------
  if (page_url.includes("find")) {
    const hasQuery = page_url.includes("find?first-name");

    if (!hasQuery) {
      document.body.classList.add("giftregistry-find-main-normal");

      const findHeader = document.querySelector(
        ".giftreggie-find .giftreggie-header p",
      );
      if (findHeader) findHeader.innerHTML = "Find a registry";

      const inputs = document.querySelectorAll(
        ".giftreggie-find .giftreggie-body input",
      );
      if (inputs[0]) inputs[0].setAttribute("placeholder", "First Name");
      if (inputs[1]) inputs[1].setAttribute("placeholder", "Last Name");
      if (inputs[2]) inputs[2].value = "SUBMIT";

      const findH3 = document.querySelector(".giftreggie-find h3");
      if (findH3) {
        const desc = document.createElement("div");
        desc.id = "description";
        desc.textContent =
          "Enter a first or last name below to locate an existing registry.";
        findH3.insertAdjacentElement("afterend", desc);
      }

      const footerLink = document.querySelector(
        ".giftreggie-find .giftreggie-footer a",
      );
      if (footerLink) footerLink.textContent = "Registry home";

      const findH3Header = document.querySelector(
        ".giftreggie-find .giftreggie-header h3",
      );
      if (findH3Header) findH3Header.textContent = "Gift Registry";

      const firstInput = document.querySelector(
        ".giftreggie-find form.gift-reggie-search-form input:first-child",
      );
      if (firstInput) firstInput.required = true;
    } else {
      document.body.classList.add("giftregistry-find-main-searched");

      const findH3Header = document.querySelector(
        ".giftreggie-find .giftreggie-header h3",
      );
      if (findH3Header) findH3Header.textContent = "Gift Registry";
      // if (findH3Header) findH3Header.classList.add("hidden");

      const findHeaderLink = document.querySelector(
        ".giftreggie-find .giftreggie-header a",
      );
      if (findHeaderLink) {
        findHeaderLink.innerHTML =
          "Don't see the registry you're looking for? search again";
        const searchResult = document.createElement("p");
        searchResult.textContent = "Search Results";
        findHeaderLink.insertAdjacentElement("beforebegin", searchResult);
      }

      const footerLink = document.querySelector(
        ".giftreggie-find .giftreggie-footer a",
      );
      if (footerLink) footerLink.textContent = "Registry home";

      const findFooter = document.querySelector(
        ".giftreggie-find .giftreggie-footer",
      );
      if (findFooter) {
        findFooter.insertAdjacentHTML(
          "afterbegin",
          `
          <div class="giftreggie-find-reg-btn">
            <a href="/apps/giftregistry/signup">CREATE A REGISTRY</a>
            <a href="/account/login?checkout_url=%2Fapps%2Fgiftregistry%2Fmanage%3Flang%3D">MANAGE YOUR REGISTRY</a>
          </div>`,
        );
      }
    }
  }

  // -------------------------------------------------------
  // SIGNUP PAGE
  // -------------------------------------------------------
  if (page_url.includes("signup")) {
    document.body.classList.add("giftregistry-signup-main");

    const signupH3 = document.querySelector(
      ".giftregistry-signup-main .giftreggie-header h3",
    );
    if (signupH3) signupH3.textContent = "Gift Registry";

    const signupHeaderP = document.querySelector(
      ".giftregistry-signup-main .giftreggie-header p",
    );
    if (signupHeaderP) {
      signupHeaderP.innerHTML = "Registry sign up";
      signupHeaderP.insertAdjacentHTML(
        "beforebegin",
        `<p class="signup-heading">Joyful occasions or "just because" — perfect picks for everyone, including yourself. Complete the form below to create an account.</p>`,
      );
    }

    const registryLink = document.querySelector(".registry-link");
    if (registryLink) {
      registryLink.parentElement.innerHTML = `<a href="/account/login?checkout_url=%2Fapps%2Fgiftregistry%2Ffind%3Flang%3D">Registry home</a>`;
    }

    const signupFooter = document.querySelector(
      ".giftregistry-signup-main .giftreggie-footer",
    );
    if (signupFooter) {
      signupFooter.insertAdjacentHTML(
        "afterend",
        `
        <div class="giftreggie-inner2">
          <div class="giftreggie-inner2-first">
            <p>FIND A REGISTRY</p>
            <p>Enter a first or last name of a registrant to search our directory</p>
          </div>
          <div class="giftreggie-inner2-second">
            <form action="/apps/giftregistry/find" method="get" class="gift-reggie-search-form">
              <p><span>First Name</span><span><input name="first-name" type="text" placeholder="First Name"></span></p>
              <p><span>Last Name</span><span><input name="last-name" type="text" placeholder="Last Name"></span></p>
              <p><span>&nbsp;</span><span><input type="submit" value="Search"></span></p>
            </form>
          </div>
        </div>`,
      );
    }

    _buildPasswordFields();
    _setPlaceholders();
  }

  // -------------------------------------------------------
  // CREATE PAGE
  // -------------------------------------------------------
  if (page_url.includes("/apps/giftregistry/create")) {
    document.body.classList.add("giftregistry-create-main");

    const createH3 = document.querySelector(
      ".giftregistry-create-main .giftreggie-header h3",
    );
    if (createH3) createH3.textContent = "Gift Registry";

    const createHeaderP = document.querySelector(
      ".giftregistry-create-main .giftreggie-header p",
    );
    if (createHeaderP) {
      createHeaderP.innerHTML = "CREATE A REGISTRY";
      createHeaderP.insertAdjacentHTML(
        "afterend",
        `<p class="com-gif-reg">Complete the form below to create your gift registry</p>`,
      );
    }

    let i = 1;
    document
      .querySelectorAll(".giftregistry-create-main .giftreggie-front p")
      .forEach((el) => {
        i++;
        el.classList.add(`pagepara-${i}`);
      });
  }

  // -------------------------------------------------------
  // REGISTRY PAGE
  // -------------------------------------------------------
  if (page_url.includes("/giftregistry/registry")) {
    document.body.classList.add("giftregistry-registry");

    const thCells = document.querySelectorAll("table#view-registry th");
    if (thCells[1]) thCells[1].textContent = "product";

    const menuItems = document.querySelectorAll(
      ".giftregistry-registry ul#giftreggie-admin-menu li",
    );
    if (menuItems[0])
      menuItems[0].querySelector("a").textContent = "Edit Registry";
    if (menuItems[2])
      menuItems[2].querySelector("a").textContent = "Edit profile";
  }

  // -------------------------------------------------------
  // MANAGE PAGE
  // -------------------------------------------------------
  if (page_url.includes("manage")) {
    const bodyDivLength = document.querySelectorAll(
      ".giftreggie-body div",
    ).length;

    document.body.classList.add("giftregistry-manage");

    const manageH3 = document.querySelector(
      ".giftregistry-manage .giftreggie-header h3",
    );
    if (manageH3) {
      manageH3.textContent = "Gift Registry";
      manageH3.insertAdjacentHTML(
        "afterend",
        `<div id="manage_registry">Manage registries</div>`,
      );
      
    }

    const manageHeaderP = document.querySelector(
      ".giftregistry-manage .giftreggie-header p",
    );
    if (manageHeaderP) manageHeaderP.innerHTML = "";

    if (bodyDivLength === 0) {
      const manageBody = document.querySelector(
        ".giftregistry-manage .giftreggie-body",
      );
      if (manageBody) manageBody.innerHTML = "";

      const manageHeader = document.querySelector(
        ".giftregistry-manage .giftreggie-header",
      );
      if (manageHeader) {
        manageHeader.insertAdjacentHTML(
          "afterend",
          `
          <div class="description_button_wrapper">
            <div class="content_wrapper">
              You aren't currently managing any registries.
              <div class="nextP">Make sure you are logged in the correct account.</div>
            </div>
            <div class="button_wrapper"><a href="/apps/giftregistry/create?sid=PDrFlzzt7BG2t1E1BhMMhQ">Create a Registry</a></div>
            <div class="home_btn"><a href="https://nickeykehoe.com/apps/giftregistry">REGISTRY HOME</a></div>
          </div>`,
        );
      }

      const manageBodyEl = document.querySelector(
        ".giftregistry-manage .giftreggie-body",
      );
      if (manageBodyEl) {
        manageBodyEl.insertAdjacentHTML(
          "afterend",
          `<div class="giftreggie-footer"></div>`,
        );
      }

      const manageFooter = document.querySelector(
        ".giftregistry-manage .giftreggie-footer",
      );
      if (manageFooter) {
        manageFooter.insertAdjacentHTML(
          "afterend",
          `
          <div class="giftreggie-inner2">
            <div class="giftreggie-inner2-first">
              <p>FIND A REGISTRY</p>
              <p>Enter a first or last name of a registrant to search our directory</p>
            </div>
            <div class="giftreggie-inner2-second">
              <form action="/apps/giftregistry/find" method="get" class="gift-reggie-search-form">
                <p><span>First Name</span><span><input name="first-name" type="text" placeholder="First Name"></span></p>
                <p><span>Last Name</span><span><input name="last-name" type="text" placeholder="Last Name"></span></p>
                <p><span>&nbsp;</span><span><input type="submit" value="Search"></span></p>
              </form>
            </div>
          </div>`,
        );
      }

      _buildPasswordFields();
      _setPlaceholders();
    }
  }

  // -------------------------------------------------------
  // PROFILE PAGE
  // -------------------------------------------------------
  if (page_url.includes("/profile")) {
    document.body.classList.add("giftregistry-create-main", "profile-main");

    document
      .querySelectorAll("ul#giftreggie-admin-menu li")
      .forEach((li) => li.classList.remove("active"));
    const menuItems = document.querySelectorAll("ul#giftreggie-admin-menu li");
    if (menuItems[1]) menuItems[1].classList.add("active");

    let i = 4;
    document
      .querySelectorAll(".giftregistry-create-main .giftreggie-front p")
      .forEach((el) => {
        i++;
        el.classList.add(`pagepara-${i}`);
      });
  }

  // -------------------------------------------------------
  // SHARE PAGE
  // -------------------------------------------------------
  if (page_url.includes("/share")) {
    document.body.classList.add("giftregistry-share");

    document
      .querySelectorAll("ul#giftreggie-admin-menu li")
      .forEach((li) => li.classList.remove("active"));
    const menuItems = document.querySelectorAll("ul#giftreggie-admin-menu li");
    if (menuItems[2]) menuItems[2].classList.add("active");
  }

  // -------------------------------------------------------
  // LANDING OVERVIEW BUTTONS
  // -------------------------------------------------------
  const isLandingRoot =
    page_url === "https://nickeykehoe.com/apps/giftregistry" ||
    page_url.includes("https://nickeykehoe.com/apps/giftregistry?sid") ||
    page_url.includes("https://nickeykehoe.com/apps/giftregistry/?sid");

  if (isLandingRoot) {
    const overviewItems = document.querySelectorAll(
      ".giftreggie-landing-overview",
    );
    const overviewPs = document.querySelectorAll(
      ".giftreggie-landing-overview p",
    );

    if (overviewPs[0]) overviewPs[0].textContent = "Find a registry";
    if (overviewItems[1]) overviewItems[1].classList.add("second_btn");
    if (overviewPs[1]) overviewPs[1].textContent = "Create a registry";
    if (overviewPs[2]) overviewPs[2].textContent = "MANAGE YOUR REGISTRY";
  }

  // -------------------------------------------------------
  // HELPERS
  // -------------------------------------------------------
  function _buildPasswordFields() {
    const passwordEl = document.getElementById("signup-password");
    const confirmEl = document.getElementById("signup-password-confirmation");

    if (passwordEl) passwordEl.closest("p")?.remove();
    if (confirmEl) confirmEl.closest("p")?.remove();

    const signupBtn = document.getElementById("signup-button");
    if (signupBtn) {
      signupBtn.closest("p")?.insertAdjacentHTML(
        "beforebegin",
        `
        <div class="signup-50">
          <p>
            <span><label for="signup_password">Password</label></span>
            <span><input type="password" name="customer[password]" id="signup-password"></span>
          </p>
          <p>
            <span><label for="signup_password_confirmation">Confirm Password</label></span>
            <span><input type="password" name="customer[password_confirmation]" id="signup-password-confirmation"></span>
          </p>
          <p class="already-acc">
            <span>Already have an account?</span>
            <span><a href="/account/login?checkout_url=%2Fapps%2Fgiftregistry%2Ffind%3Flang%3D">login</a></span>
          </p>
        </div>`,
      );
    }
  }

  function _setPlaceholders() {
    const fields = {
      "#signup-first-name": "First Name",
      "#signup-last-name": "Last Name",
      "#signup-email": "Email",
      "#signup-password": "Password",
      "#signup-password-confirmation": "Confirm Password",
    };
    Object.entries(fields).forEach(([selector, placeholder]) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("placeholder", placeholder);
    });
  }
});
